export function getBrowserInfo(): string {
  const ua = navigator.userAgent;
  // Edge UA contains both "Edg" and "Chrome" — check Edge first
  const browsers: Array<[string, string]> = [
    ['Edg', 'Edge'],
    ['Firefox', 'Firefox'],
    ['Chrome', 'Chrome'],
    ['Safari', 'Safari'],
  ];
  for (const [token, label] of browsers) {
    const match = ua.match(new RegExp(`${token}\\/(\\d+)`));
    if (match) return `${label}/${match[1]}`;
  }
  return 'unknown';
}
